"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Body", {
  enumerable: true,
  get: function get() {
    return _Body.default;
  }
});
Object.defineProperty(exports, "ClayModalProvider", {
  enumerable: true,
  get: function get() {
    return _Provider.default;
  }
});
Object.defineProperty(exports, "Context", {
  enumerable: true,
  get: function get() {
    return _Provider.Context;
  }
});
Object.defineProperty(exports, "Header", {
  enumerable: true,
  get: function get() {
    return _Header.default;
  }
});
Object.defineProperty(exports, "Item", {
  enumerable: true,
  get: function get() {
    return _Header.Item;
  }
});
Object.defineProperty(exports, "ItemGroup", {
  enumerable: true,
  get: function get() {
    return _Header.ItemGroup;
  }
});
Object.defineProperty(exports, "Modal", {
  enumerable: true,
  get: function get() {
    return _Modal.default;
  }
});
Object.defineProperty(exports, "Subtitle", {
  enumerable: true,
  get: function get() {
    return _Header.Subtitle;
  }
});
Object.defineProperty(exports, "SubtitleSection", {
  enumerable: true,
  get: function get() {
    return _Header.SubtitleSection;
  }
});
Object.defineProperty(exports, "Title", {
  enumerable: true,
  get: function get() {
    return _Header.Title;
  }
});
Object.defineProperty(exports, "TitleIndicator", {
  enumerable: true,
  get: function get() {
    return _Header.TitleIndicator;
  }
});
Object.defineProperty(exports, "TitleSection", {
  enumerable: true,
  get: function get() {
    return _Header.TitleSection;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "useModal", {
  enumerable: true,
  get: function get() {
    return _useModal.useModal;
  }
});
var _Body = _interopRequireDefault(require("./Body"));
var _Header = _interopRequireWildcard(require("./Header"));
var _Modal = _interopRequireDefault(require("./Modal"));
var _Provider = _interopRequireWildcard(require("./Provider"));
var _useModal = require("./useModal");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
var _default = exports.default = _Modal.default;